export const laboratoryFr = {
 "Laboratoires": "Laboratoires", 
 "Docteur": "Docteur",
 "Patient": "Patient",
 "Prix du lab": "Prix du lab",
 "Comptes": "Comptes",
 "Consommations": "Consommations",
 "Date D'empreinte": "Date D'empreinte",
 "Date RDV": "Date RDV",
 "Patient Non Terminer": "Patients Non Terminer",
 "Comment": "Commentaire",
 "Prix": "Prix",

  // Server side 

  "Le laboratoire deja existe.": "Le laboratoire deja existe.",
  "Le nom du laboratoire est obligatoire !!": "Le nom du laboratoire est obligatoire !!",
  "Le docteur est obligatoire": "Le docteur est obligatoire",
  "Le montant est obligatoire": "Le montant est obligatoire",
  "le traitement deja existe": "le traitement deja existe",
  "Donner le traitement": "Donner le traitement",
  "Donner le prix": "Donner le prix",
  "Paiements Labo" : "Paiements Labo", 


}